import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/zus/declarations`;
export const modelName = 'zusdeclaration';

export default {
  ...apiCrud({ baseUri, modelName }),
};
